module.exports = __webpack_public_path__ + "img/hoslogo1.b7cab204.png";